import React, {useEffect} from 'react'
import UiInputText from "../components/Form/UiInputText";
import UiInputCheckbox from "../components/Form/UiInputCheckbox";
import Form from "../components/Form/Form";
import {useForm, FormProvider} from "react-hook-form";
import WindowBody from '../components/Window/WindowBody';
import WindowFooter from '../components/Window/WindowFooter';
import { UiButton } from '../components/UiButton';

export default function DepositoForm(props: any){
    const methods = useForm({
        defaultValues: props.data || { ativo: true }
    });
    const { handleSubmit, reset } = methods;

    useEffect(() => {
        if (props.data) {
            reset(props.data);
        }
    }, [props.data, reset]);

    return (
        <FormProvider {...methods}>
            <Form onSubmit={handleSubmit(props.triggerSubmit)} methods={methods}>
                <WindowBody>
                    <div className="row">
                        <UiInputText size={12} name="nome" label="Nome"/>
                        <UiInputCheckbox size={3} name="ativo" label="Ativo"/>
                    </div>
                </WindowBody>

                <WindowFooter>
                    <UiButton variant="secondary" onClick={props.triggerClose}>Fechar</UiButton>
                    <UiButton variant="primary" type="submit">Salvar</UiButton>
                </WindowFooter>
            </Form>
        </FormProvider>
    )
}
